export default "__VITE_ASSET__Co2c_Q2b__"